import { render, staticRenderFns } from "./AfterResetModal.vue?vue&type=template&id=15a2b206&scoped=true&"
import script from "./AfterResetModal.vue?vue&type=script&lang=js&"
export * from "./AfterResetModal.vue?vue&type=script&lang=js&"
import style0 from "./AfterResetModal.vue?vue&type=style&index=0&id=15a2b206&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a2b206",
  null
  
)

export default component.exports